// 权限管理
const reportQuery = () => import(/* webpackChunkName: "labourUnionBusinessReport" */ '../../views/labourUnionBusinessReport/index');
export default [
    {
        path: '/labourUnionBusinessReport/reportQuery',
        name: 'reportQuery',

        meta: { title: '报表查询',selfFlg: 'reportQuery', },
        component: reportQuery
    }
];
